import {Skeleton, Stack} from "@mui/material";
import React from "react";

interface Props {
  testId: string;
}

const RadioSkeleton = ({
  testId
}: Props) => (
  <Stack
    width="100%"
    direction="row"
    gap="1.2rem"
    data-testid={`${testId}_radio-skeleton`}
    alignItems="center"
    sx={{
      flexDirection: {xs: "column", md: "row"},
      alignItems: {xs: "start", md: "center"}
    }}
  >
    <Skeleton width="20rem" height="2rem" />
    <Stack direction="row" gap="0.8rem" alignItems="center">
      <Skeleton variant="circular" height="1.5rem" width="1.5rem" />
      <Skeleton width="8rem" height="2rem" />
      <Skeleton variant="circular" height="1.5rem" width="1.5rem" />
      <Skeleton width="8rem" height="2rem" />
    </Stack>
  </Stack>
);

export default RadioSkeleton;